import { render, staticRenderFns } from "./editTexture.vue?vue&type=template&id=bf1ed4c0&scoped=true"
import script from "./editTexture.vue?vue&type=script&lang=js"
export * from "./editTexture.vue?vue&type=script&lang=js"
import style0 from "./editTexture.vue?vue&type=style&index=0&id=bf1ed4c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf1ed4c0",
  null
  
)

export default component.exports